<template>
  <v-container fluid>
    <!-- <el-overlay-loading :loading="pageloading" /> -->
    <h3 ref="topZinute" class="mb-5">Sistemos atnaujinimai</h3>

    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :item-class="rowClass"
      :loading="loading"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      :hide-default-footer="hideFooter"
      @update:options="updatePagination"
    >
      <template #top>
        <v-toolbar flat>
          <v-spacer></v-spacer>
          <el-button-prideti primary @click.native.stop="newZinute()">
            Pridėti pranešimą
          </el-button-prideti>
        </v-toolbar>
      </template>
      <template #[`item.roles`]="{ item }">
        <v-row dense no-gutters>
          <v-col cols="12" md="12">
            <v-row dense no-gutters>
              <v-col cols="12" md="12" v-for="role in item.roles" :key="role">
                {{ role }}
              </v-col>
              <v-col cols="12" md="12" v-if="item.rolesCut">
                ...
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>
      <template #[`item.zin_pavadinimas`]="{ item }">
        <div class="text-cut-4">
          <span v-html="item.zin_pavadinimas"></span>
        </div>
      </template>
      <template #[`item.zin_aktyvus`]="{ item }">
        <el-busena :busena="item.zin_aktyvus" taip-ne />
      </template>
      <template #[`item.zin_galioja_nuo`]="{ item }">
        <div class="nowrap">{{ item.zin_galioja_nuo_diena }}</div>
        <div class="nowrap">{{ item.zin_galioja_nuo_laikas }}</div>
      </template>
      <template #[`item.zin_galioja_iki`]="{ item }">
        <div class="nowrap">{{ item.zin_galioja_iki_diena }}</div>
        <div class="nowrap">{{ item.zin_galioja_iki_laikas }}</div>
      </template>
      <template #[`item.zin_atnaujinimo_data`]="{ item }">
        <div class="nowrap">{{ item.zin_atnaujinimo_data_diena }}</div>
        <div class="nowrap">{{ item.zin_atnaujinimo_data_laikas }}</div>
      </template>
      <template #[`item.actions`]="{ item }">
        <el-table-action
          :item="item"
          @editItem="openZinute(item.zin_id)"
          @deleteItem="deleteZinute(item)"
        />
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <admin-zinute-detail
      v-model="showZinute"
      :key="zinuteKey"
      :zinute-id="zinuteId"
      :zinute-roles="zinute_roles"
      @resetZinute="resetZinute"
      @updateList="updateList"
    />

    <modal-delete
      title="Pašalinti pranešimą"
      :text="modalDeleteText"
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import AdminZinuteDetail from './AdminZinuteDetail'
import ModalDelete from '../modals/ModalDelete'
import rowClass from '../../mixins/rowClass'

export default {
  name: 'AdminZinute',
  components: { AdminZinuteDetail, ModalDelete },
  mixins: [rowClass],
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      zinutes: [],
      zinuteId: null,
      search: null,
      searchData: {},
      itemsPerPageOptions: [20, 50, 100],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
      showDelete: false,
      modalDeleteText: null,
      modalDeleteItem: null,
      zinuteRefresh: 0,
      showZinute: false,
      zinute_roles: [],
      selectedZinuteId: null,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Eil. nr.',
          align: 'start',
          value: 'zin_eil_nr',
          width: 60,
        },
        {
          text: 'Rolės',
          align: 'start',
          value: 'roles',
          width: 180,
        },
        {
          text: 'Pavadinimas',
          align: 'start',
          value: 'zin_pavadinimas',
        },
        {
          text: 'Aktyvus',
          align: 'center',
          value: 'zin_aktyvus',
        },
        {
          text: 'Peržiūrų sk.',
          align: 'center',
          value: 'perziuros',
        },
        {
          text: 'Vaizdavimo data ir laikas nuo',
          align: 'center',
          value: 'zin_galioja_nuo',
          width: 100,
        },
        {
          text: 'Vaizdavimo data ir laikas iki',
          align: 'center',
          value: 'zin_galioja_iki',
          width: 100,
        },
        {
          text: 'Paskutinis veiksmus atlikęs asmuo',
          align: 'start',
          value: 'atnaujino',
        },
        {
          text: 'Paskutinio veiksmo data ir laikas',
          align: 'center',
          value: 'zin_atnaujinimo_data',
          width: 120,
        },
        {
          text: 'Veiksmai',
          align: 'center',
          sortable: false,
          value: 'actions',
          width: 100,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.zinutes.map(item => {
        item.roles = item.zin_roles ?? []
        if (item.zin_visos_roles) {
          item.roles = ['Visos rolės']
        }
        const maxRoles = 5
        item.rolesCut = false
        if (item.roles.length > maxRoles) {
          item.roles = item.roles.slice(0, maxRoles)
          item.rolesCut = true
        }

        item.canEdit = true
        item.canDelete = true
        return item
      })
    },
    hideFooter() {
      return this.pagination.total <= 5
    },
    deleteTile() {
      return this.isAprasymas ? 'Šalinti aprašymą' : 'Šalinti patartį (tooltip)'
    },
    zinuteKey() {
      return `zinute-${this.zinuteRefresh}`
    },
  },
  created() {
    this.getData()
    this.getRolesList()
  },
  methods: {
    searchZinute(searchData) {
      this.searchData = searchData
      this.getData()
    },
    getData(resetPageNr = false) {
      this.pageloading = true
      this.loading = true

      if (resetPageNr) {
        this.pagination.page = 1
      }
      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`admin/zinute/sarasas`, data)
        .then(res => {
          this.zinutes = res.data.zinutes
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    getRolesList() {
      const data = {
        klasifikatoriai: ['admin_zinute_roles'],
      }

      this.$axios
        .post(`klasifikatorius/list`, data)
        .then(res => {
          this.zinute_roles = res.data.list.admin_zinute_roles
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {})
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    newZinute() {
      this.openZinute(0)
    },
    openZinute(zinuteId) {
      this.zinuteRefresh++
      this.zinuteId = zinuteId
      this.showZinute = true
    },
    resetZinute() {
      this.zinuteId = 0
    },
    updateList() {
      this.getData()
      // this.$vuetify.goTo(this.$refs.topZinute)
    },
    deleteZinute(item) {
      this.modalDeleteText = `Ar norite pašalinti pranešimą <strong>${item.zin_pavadinimas}</strong>?`
      this.modalDeleteItem = { zin_id: item.zin_id }
      this.showDelete = true
    },
    confirmDelete(item) {
      if (!item.zin_id) {
        return
      }
      this.loading = true
      this.showZinute = false

      this.$axios
        .delete(`admin/zinute/${item.zin_id}`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData(true)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getActiveClass(item) {
      if (item.zin_id === this.zinuteId) {
        return 'row-selected'
      }
      return ''
    },
  },
}
</script>
